import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'
import {alert, getLocalstorage, setLocalstorage} from '@/utils/utils'
import { getUserInfo } from '@/utils/common'
import * as api from '@/api/user'

const Context = createContext<{
  userInfo: any
  baseInfo: any
  updateUserInfo: (data: any) => void
  updateBaseInfo: () => void
  clear: () => void
  topPermissions: any[]
  updateTopPermissions: () => void
}>({
  userInfo: {},
  baseInfo: {},
  updateUserInfo() {},
  updateBaseInfo() {},
  clear() {},
  topPermissions: [],
  updateTopPermissions() {},
})

export const UserInfoProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState({})
  const [baseInfo, setBaseInfo] = useState<any>({})
  const [done, setDone] = useState(false)
  const [topPermissions, setTopPermissions] = useState([])

  const updateTopPermissions = useCallback( async () => {
    const res = await api.getTopPermissions()
    if(res.success) {
      setTopPermissions(res.data)
    }
  }, [])

  useEffect(() => {
    updateTopPermissions()
  }, [updateTopPermissions])

  // 清空登录
  const clear = useCallback(() => {
    setBaseInfo({})
    setUserInfo({})
    setLocalstorage('userinfo', null)
  }, [])

  // 更新基本数据
  const updateBaseInfo = useCallback(async() => {
    const res = await api.getCurrentUser()
    if(res && res.userid) {
      if(res.userid === "-1"){
        alert("提示信息",res.msg,  () => {
          clear()
          window.location.reload()
        })
        return
      }
      // 更新本地缓存登录数据到状态
      const userInfo = getLocalstorage('userinfo')
      setUserInfo(userInfo)
      // 更新用户数据
      setBaseInfo({
        ...res
      })
      setDone(true)
    }else {
      alert("提示信息",res && res.msg || '获取用户信息失败',  () => {
        clear()
        window.location.reload()
      })
    }
  }, [clear])

  const updateUserInfo = useCallback(async(data) => {
    setUserInfo(data)
    setLocalstorage('userinfo', data)
    updateTopPermissions()
    updateBaseInfo()
  }, [updateBaseInfo, updateTopPermissions])

  useEffect(() => {
    const userInfo = getLocalstorage('userinfo')
    setUserInfo(userInfo)
    if(userInfo) {
      updateBaseInfo()
    } else {
      setDone(true)
    }
  }, [updateBaseInfo])

  return (
    <Context.Provider value={{ baseInfo, topPermissions, userInfo, updateUserInfo, updateBaseInfo, clear, updateTopPermissions }}>
      {done && children}
    </Context.Provider>
  );
}

export const useUserInfoContext = () => {
  return useContext(Context)
}

export default Context